import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import { Box, CircularProgress, Typography, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import constant from "../../Shell/Constant";
import { Logo } from "../../AssetsV2";
import { AuthRootWrapper } from "../../ComponentsV2/wrappers/StyledWrappers";
import AuthService, { GetUserTokenFromKitchenCode, GetCenterInfo, GetTokenFromToken } from "../../Services/AuthService";
import { kitchenStorage } from "../../Services/Storage/StorageSections/kitchen.storage";
import { showToast } from "../../Store/Slices/toastSlice";
const Root = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    background: theme.palette.primary.main,
    width: '100%',
    height: '100dvh',
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: '100',


}));
export default function Access() {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    // get params kitchenCode from URL using router dom 
    const searchParams = new URLSearchParams(window.location.search);
    const kitchenCode = searchParams.get('kitchenCode');


    const hostName = window.location.hostname;
    useEffect(() => {
        // take load time befor redirecting
        setTimeout(() => {
            handleAccess();
        }, 1000);
    }, [])
    const handleAccess = async () => {

        if (constant?.kitchenProtectedDomains?.includes(hostName)) {
            const tokenUID = AuthService.getUserData("tokenUID");
            if (tokenUID) {
                navigate("/kitchen-meals-list");
                return;
            }
            let success = await ResolveUserToken()
            if (success) {
                return;
            } else {
                navigate("/login-options");
                return;
            }
        }
        if (hostName === constant.driversDomain) {
            navigate("/verifyByToken")
        } else {
            let userData = localStorage.getItem('USER_DATA') ? JSON.parse(localStorage.getItem('USER_DATA')) : null;
            if (userData && userData?.AuthToken) {
                navigate("/verifyByToken")
            } else {
                navigate("/phone-verification")
            }
        }
    }
    const ResolveUserToken = async () => {
        try {
            if (!kitchenCode) {
                console.log("Kitchen code is missing.")
                return false;
            }
            let response = await GetUserTokenFromKitchenCode(kitchenCode);
            if (response?.userToken) {
                AuthService.setUserData("tokenUID", response?.userToken);
                if (response?.kitchenId) {
                    kitchenStorage.setScannedKitchenId(response?.kitchenId);
                    kitchenStorage.setSelectedKitchenId(response?.kitchenId);
                }
                // const centerResponse = await GetCenterInfo(response?.userToken);
                // console.log(centerResponse);
                // if (centerResponse?.success && centerResponse?.data?.length > 0) {
                //     const defaultCenter = centerResponse.data[0];
                //     const tokenResponse = await GetTokenFromToken(defaultCenter?.gsid);
                //     if (tokenResponse?.success) {
                //         AuthService.setUserData("tokenUID", tokenResponse?.data);
                //     }
                //     AuthService.setUserData("gsid", defaultCenter?.gsid);
                //     AuthService.setUserData("centerInfo", defaultCenter);
                //     localStorage.setItem("centerData", JSON.stringify(centerResponse.data));
                // } else {
                //     localStorage.setItem("centerData", JSON.stringify([]));
                // }
                navigate("/kitchen-meals-list")
                return true;
            } else {
                dispatch(showToast({ message: response?.message || "Failed to resolve user token.", variant: "warning" }));
                console.error(`Failed to resolve user token for kitchenCode: ${kitchenCode}`);
                return false;
            }
        } catch (error) {
            dispatch(showToast({ message: "Error occurred while resolving user token.", variant: "error" }));
            console.error(`Error occurred while resolving user token for kitchenCode: ${kitchenCode}`, error);
            return false;
        }
    }


    return (
        // <AuthRootWrapper>
        //     <Box className="mainContainer">
        //         <Box className="content">
        //             <CircularProgress size={50} sx={{ color: "#fff" }} />
        //             <Box> <img src={Logo} alt="heartpng" /> </Box>
        //             <Typography className="heading" sx={{ fontSize: '36px !important' }}
        //                 variant="h1"
        //             >
        //                 My Senior Center
        //             </Typography>
        //             <Box className="footerBox" >
        //                 <Typography variant="subtitle2" className='footerText' onClick={() => { navigate('/verifyByToken') }} >
        //                     Join a network of over 1,900 senior centers that trust MySeniorCenter to streamline operations, improve engagement, and simplify daily tasks.
        //                 </Typography>
        //             </Box>

        //         </Box>
        //     </Box>
        // </AuthRootWrapper>
        <Root p={2} sx={{ display: 'flex' }}>
            <CircularProgress sx={{ color: theme => theme.palette.text.secondary }} />
        </Root>
    );
}
